import Sdk from 'api.digitalpages.module.sdk.api';

class AuthorService {
  static authorsCache = null;

  static async loadAuthors() {
    if (this.authorsCache) {
      return this.authorsCache;
    }

    try {
      const url = 'auth/v1.1/entity/schema/available?type=category';
      const raw = await Sdk.Api.dynamic.bridge(url, null, "GET");
      const schemas = raw?.result || raw || [];

      const authorSchema = schemas.find(
        schema => schema.name === "Authors" ||
                 schema.name === "Autores" ||
                 schema.name === "Autor"
      );

      if (authorSchema) {
        const entitiesUrl = `auth/v1.1/entity/schema/uid/${authorSchema.uid}/items/tree`;
        const rawEntities = await Sdk.Api.dynamic.bridge(entitiesUrl, null, "GET");
        const entities = rawEntities?.result || rawEntities || [];

        this.authorsCache = this.flattenAuthors(entities);
      } else {
        this.authorsCache = [];
      }

      return this.authorsCache;
    } catch (error) {
      console.error('Error loading authors:', error);
      return [];
    }
  }

  static flattenAuthors(entities) {
    const authors = [];
    
    const processEntity = (entity) => {
      authors.push({
        uid: entity.uid,
        label: entity.name
      });
      
      var subs = entity.childs || entity.children;
      if (subs) {
        subs.forEach(processEntity);
      }
    };

    entities.forEach(processEntity);
    return authors;
  }

  static updateContentAuthor(content, authors, joinSymbol = ' | ') {
    if (!content.entities || !content.entities.length || !authors.length) {
      return content.author || 'Autor não disponível';
    }
    const names = authors
      .filter(author => content.entities.find(e => e.entity_uid === author.uid || e.uid === author.uid))
      .map(author => author.label.trim())
      .join(joinSymbol);

    return names || 'Autor não disponível';
  }

  static clearCache() {
    this.authorsCache = null;
  }
}

export default AuthorService;